import { ChildModel, ModelBase } from 'store/model-base';

import { ReturnEligibility } from './return-eligibility';

export class ReturnEligibilityCollection extends ModelBase {
    public static storeName: string = 'returnEligibilityCollection';

    public returnEligibility: ReturnEligibility[];
    public orderId: string;

    public hasReturnEligible: boolean;
    public hasExchangeEligible: boolean;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: ReturnEligibilityCollection = super.create<ReturnEligibilityCollection>(initData);

        toReturn.hasReturnEligible = Boolean(toReturn.returnEligibility.find((eligible: ReturnEligibility) => eligible.returnEligibility));
        toReturn.hasExchangeEligible = Boolean(toReturn.returnEligibility.find((eligibility: ReturnEligibility) => eligibility.exchangeEligibility));

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'returnEligibility',
            model: ReturnEligibility
        }];
    }
}
